<template>
  <Application>
    <b-breadcrumb :items="items"></b-breadcrumb>

    <b-row>
      <b-col>
        <ClientProfile mode="CREATE"/>
      </b-col>
    </b-row>
  </Application>
</template>

<script>
import Application from '@/components/Application/Application.vue';
import ClientProfile from '@/components/Clients/Profile.vue';

export default {
  components: {
    Application,
    ClientProfile,
  },

  data() {
    return {
      items: [
        { text: 'Dashboard', to: '/' },
        { text: 'Clientes', to: '/clients' },
        { text: 'Novo cliente', active: true },
      ],
    };
  },
};
</script>
